import APIManager from 'api/APIManager';
import APIConstant from 'api/APIConstant';
import { parameterToPath } from 'utils';

export type Review = {
  review_id?: number; // 리뷰 idx
  user_id?: number; // 유저 idx
  parcel_service_id?: number; // 정기/배송 주문 idx
  order_reservation_id?: number; // 오더/예약 idx
  rental_id?: number; // 렌탈 idx
  review_score?: number; // 리뷰 점수
  review_content?: string; // 리뷰 내용
  review_reserve?: number; // 리뷰 적립금
  is_show?: string; // 노출여부
  answer?: { [key: string]: string }[]; // 리뷰 답변
  created_at?: number; // 생성일
  updated_at?: number; // 수정일
};

const $http = new APIManager();

const Api = {
  /**
   * [GETS] Review
   * --
   */
  getReviews: async (params?: { [key: string]: string | number }) => {
    try {
      const res = await $http.get(APIConstant.GETS_REVIEW, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [GET] Review
   * --
   */
  getReview: async (
    idx: number,
    params?: { [key: string]: string | number }
  ) => {
    try {
      const url = parameterToPath(APIConstant.GET_REVIEW, { review_id: idx });
      const res = await $http.get(url, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] Review
   * --
   */
  createReview: async (body: Review) => {
    try {
      const res = await $http.post(APIConstant.CREATE_REVIEW, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [PUT] Review
   * --
   */
  updateReview: async (body: Review) => {
    try {
      const { review_id } = body;
      const url = parameterToPath(APIConstant.UPDATE_REVIEW, {
        review_id: review_id,
      });

      const res = await $http.put(url, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [DELETE] Review
   * --
   */
  deleteReview: async (idx: number) => {
    try {
      const url = parameterToPath(APIConstant.UPDATE_REVIEW, {
        review_id: idx,
      });

      const res = await $http.delete(url);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [PUT] Review
   * --
   */
  upsertReview: async (body: Review[]) => {
    try {
      const res = await $http.put(APIConstant.UPSERT_REVIEW, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [DELETE] Review
   * --
   */
  bulkDeleteReview: async (body: Review[]) => {
    try {
      const res = await $http.bulk(
        APIConstant.BULK_DELETE_REVIEW,
        body,
        'DELETE'
      );

      return res;
    } catch (e) {
      throw e;
    }
  },
};

export default Api;
